import _ from 'lodash';

const MESSAGE_SELECTOR = '[data-availability-overnight="message"]';
const OPEN_TIME_INPUT_SELECTOR = '[data-availability-overnight="open_time"]';
const CLOSE_TIME_INPUT_SELECTOR = '[data-availability-overnight="close_time"]';

const getTimes = $fields => {
  return {
    openTime: $fields.find(OPEN_TIME_INPUT_SELECTOR).inputmask('unmaskedvalue'),
    closeTime: $fields
      .find(CLOSE_TIME_INPUT_SELECTOR)
      .inputmask('unmaskedvalue')
  };
};

const getNormalizedTime = time => {
  const timeNumber = parseFloat(time);
  const amPm = time.slice(4, 5);
  return amPm == 'a' ? timeNumber : timeNumber * 12 * 60;
};

const onTimeChange = _.throttle(event => {
  const $input = $(event.target);
  const $fields = $input.closest('.nested-fields');
  const { openTime, closeTime } = getTimes($fields);

  if (openTime.length == 5 && closeTime.length == 5) {
    const isOvernight =
      getNormalizedTime(openTime) <= getNormalizedTime(closeTime);
    $fields.find(MESSAGE_SELECTOR).toggleClass('hidden', isOvernight);
  }
}, 200);

class AvailabilityOvernight {
  constructor() {
    $('body').on(
      'keyup blur',
      `${OPEN_TIME_INPUT_SELECTOR}, ${CLOSE_TIME_INPUT_SELECTOR}`,
      onTimeChange
    );
  }
}

export default AvailabilityOvernight;



// WEBPACK FOOTER //
// ./src/javascripts/AvailabilityOvernight.js